import { createFileRoute } from '@tanstack/react-router';
import { type AggregateBreadcrumb, buildBreadcrumb } from '@interxfi/app-components/components/router-breadcrumbs/router-breadcrumbs';
import { O5_STACK_BASE_PATH } from '../../../../../../features/o5/stack/o5-stack-routing';

export const Route = createFileRoute('/_app/_o5/_o5-required/tech-ops/stack/_stack')({
  loader: () =>
    ({
      breadcrumb: buildBreadcrumb({
        id: 'o5-stack-list',
        label: 'Stacks',
        to: O5_STACK_BASE_PATH,
      }),
    }) satisfies AggregateBreadcrumb,
});
